var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Manage Autoupdate Settings ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-form",
            {
              attrs: {
                disabled: _vm.loading
              }
            },
            [
              _c(
                "v-radio-group",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    name: "Option",
                    "error-messages": _vm.errors.collect("Option"),
                    disabled: _vm.loadingInstallations
                  },
                  model: {
                    value: _vm.auto_upgrade_core,
                    callback: function callback($$v) {
                      _vm.auto_upgrade_core = $$v
                    },
                    expression: "auto_upgrade_core"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      label: "Do not upgrade",
                      value: 0
                    }
                  }),
                  _c("v-radio", {
                    attrs: {
                      label: "Upgrade to minor version only",
                      value: 1
                    }
                  }),
                  _c("v-radio", {
                    attrs: {
                      label: "Upgrade to any latest version available",
                      value: 2
                    }
                  })
                ],
                1
              ),
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  label: "Auto Upgrade Plugins",
                  disabled: _vm.loadingInstallations,
                  "true-value": 1,
                  "false-value": 0,
                  color: "primary"
                },
                model: {
                  value: _vm.auto_upgrade_plugins,
                  callback: function callback($$v) {
                    _vm.auto_upgrade_plugins = $$v
                  },
                  expression: "auto_upgrade_plugins"
                }
              }),
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  label: "Auto Upgrade Themes",
                  disabled: _vm.loadingInstallations,
                  "true-value": 1,
                  "false-value": 0,
                  color: "primary"
                },
                model: {
                  value: _vm.auto_upgrade_themes,
                  callback: function callback($$v) {
                    _vm.auto_upgrade_themes = $$v
                  },
                  expression: "auto_upgrade_themes"
                }
              }),
              _c("p", [
                _vm._v(
                  " This will apply to all of your WordPress installations. "
                )
              ])
            ],
            1
          ),
          _c(
            "gg-btn",
            {
              attrs: {
                loading: _vm.loading,
                disabled: _vm.loadingInstallations
              },
              on: {
                click: _vm.save
              }
            },
            [_vm._v(" Save ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }